"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
class LoginService {
    constructor() {
        // TODO: capire come rivalorizzare questa variabile
        this.hasSiaAgency = "no";
    }
    // POST login
    static loginFn(urlToLogin, username, password, captcha) {
        return LoginService.postLogin(urlToLogin, username, password, captcha)
            .then((response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.ok) {
                return response;
            }
            return nodejs_library_1.Helpers.SessionHelper.setData("_isLogged", response.status === 200).then(() => response);
        }));
    }
    static logoutFn() {
        return LoginService.logout().then((response) => {
            if (!response.ok) {
                return response;
            }
            return nodejs_library_1.Helpers.SessionHelper.deleteAllData().then(() => response);
        });
    }
    static postLogin(urlToLogin, username, password, captcha) {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
        };
        if (captcha) {
            headers["x-token"] = captcha;
        }
        return commonNetworkService.post(urlToLogin, "username=" + username + "&password=" + encodeURIComponent(password), headers, true);
    }
    static logout() {
        const commonNetworkService = new nodejs_library_1.CommonNetworkService();
        return commonNetworkService.get("/logout", {}, true);
    }
}
exports.LoginService = LoginService;
